import React from 'react';

import { Box, Typography } from '@mui/material';

export type SearchDetailField = {
  label: string;
  value: React.ReactNode;
};

type Props = {
  title: string;
  fields: Array<SearchDetailField>;
};

function isEmptyValue(value: React.ReactNode) {
  return value === null || value === undefined || value === '';
}

export default function SearchDetailSection({ title, fields }: Props) {
  const visibleFields = fields.filter((field) => !isEmptyValue(field.value));

  return (
    <Box sx={{ flex: '1 1 0', minWidth: 0 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        {visibleFields.map((field) => (
          <Box component="li" key={field.label} sx={{ typography: 'body2', mb: 0.5 }}>
            {field.label}: {field.value}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
